var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useRef, useState } from "react";
import { useTheme, useMediaQuery } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import TaskOutlinedIcon from "@mui/icons-material/TaskOutlined";
import { Dialog, DialogContent, DialogTitle, IconButton, Stack, Typography, Button, Box, } from "@mui/material";
import { Colors } from "../util/theme";
import * as pdfjsLib from "pdfjs-dist";
pdfjsLib.GlobalWorkerOptions.workerSrc = "https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/pdf.worker.min.js";
export var ViewPdf = function (_a) {
    var isOpen = _a.isOpen, close = _a.close, base64 = _a.base64, title = _a.title;
    var _b = useState(isOpen), isModalOpen = _b[0], setIsModalOpen = _b[1];
    var _c = useState(null), pdfDoc = _c[0], setPdfDoc = _c[1];
    var canvasRef = useRef(null);
    var theme = useTheme();
    var isMobile = useMediaQuery(theme.breakpoints.down("sm"));
    useEffect(function () {
        var loadPdf = function () { return __awaiter(void 0, void 0, void 0, function () {
            var pdfData, loadingTask, doc, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        pdfData = atob(base64);
                        loadingTask = pdfjsLib.getDocument({ data: pdfData });
                        return [4 /*yield*/, loadingTask.promise];
                    case 1:
                        doc = _a.sent();
                        setPdfDoc(doc);
                        return [3 /*break*/, 3];
                    case 2:
                        error_1 = _a.sent();
                        console.error("Erro ao carregar o PDF:", error_1);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        if (base64)
            loadPdf();
    }, [base64]);
    useEffect(function () {
        var renderPage = function () { return __awaiter(void 0, void 0, void 0, function () {
            var page, viewport, canvas, context, error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!pdfDoc || !canvasRef.current)
                            return [2 /*return*/];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 5, , 6]);
                        return [4 /*yield*/, pdfDoc.getPage(1)];
                    case 2:
                        page = _a.sent();
                        viewport = page.getViewport({ scale: 1.5 });
                        canvas = canvasRef.current;
                        context = canvas.getContext("2d");
                        if (!context) return [3 /*break*/, 4];
                        canvas.height = viewport.height;
                        canvas.width = viewport.width;
                        return [4 /*yield*/, page.render({
                                canvasContext: context,
                                viewport: viewport,
                            }).promise];
                    case 3:
                        _a.sent();
                        _a.label = 4;
                    case 4: return [3 /*break*/, 6];
                    case 5:
                        error_2 = _a.sent();
                        console.error("Erro ao renderizar a página do PDF:", error_2);
                        return [3 /*break*/, 6];
                    case 6: return [2 /*return*/];
                }
            });
        }); };
        renderPage();
    }, [pdfDoc]);
    var downloadPDF = function () {
        var byteCharacters = atob(base64);
        var byteNumbers = Array.from(byteCharacters, function (char) {
            return char.charCodeAt(0);
        });
        var byteArray = new Uint8Array(byteNumbers);
        var blob = new Blob([byteArray], { type: "application/pdf" });
        var link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = "documento.pdf";
        link.click();
        URL.revokeObjectURL(link.href);
    };
    return (_jsxs(Dialog, __assign({ open: isModalOpen, onClose: close, fullScreen: isMobile, fullWidth: true, maxWidth: "xl" }, { children: [_jsxs(DialogTitle, __assign({ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "space-between" }, { children: [_jsxs(Stack, __assign({ direction: "row", alignItems: "center", gap: "1rem" }, { children: [_jsx(Stack, __assign({ bgcolor: Colors.AZUL_GOV, borderRadius: "50%", p: "0.5rem" }, { children: _jsx(TaskOutlinedIcon, { sx: { color: "white", fontSize: { xs: "medium", md: "large" } } }) })), _jsx(Typography, __assign({ variant: "h6", fontSize: { xs: "1rem", md: "1.25rem" } }, { children: title })), _jsx(Button, __assign({ onClick: downloadPDF, variant: "contained" }, { children: "Baixar" }))] })), _jsx(IconButton, __assign({ onClick: function () {
                            setIsModalOpen(false);
                            close();
                        } }, { children: _jsx(CloseIcon, {}) }))] })), _jsx(DialogContent, { children: _jsx(Box, __assign({ sx: { overflow: "auto" } }, { children: pdfDoc ? (_jsx("canvas", { ref: canvasRef })) : (_jsx(Typography, { children: "Carregando PDF..." })) })) })] })));
};
